import React from "react"
import PropTypes from "prop-types"
import StaticFilterBoxesWithStore from "../StaticFilterBoxes/StaticFilterBoxesWithStore"
import AssetFiltersWithStore from "../AssetFilters/AssetFiltersWithStore"
import "./Filters.scss"

class Filters extends React.Component {
  render() {
    if (this.props.deviceType === "desktop") {
      return (
        <div className="Filters">
          <div className="header">Found Assets</div>
          <StaticFilterBoxesWithStore />
          {this.props.loading ? null : (
            <AssetFiltersWithStore
              filteredResults={this.props.searchedAssets}
              deviceType={this.props.deviceType}
            />
          )}
        </div>
      )
    }

    return (
      <div className="Filters">
        {this.props.displayDropdown ? (
          <div className="filter-dropdown">
            <StaticFilterBoxesWithStore />
            <AssetFiltersWithStore
              filteredResults={this.props.searchedAssets}
              deviceType={this.props.deviceType}
            />
            <button
              className="clear-filters"
              onClick={this.props.onReset}
              type="reset"
            >
              CLEAR FILTERS
            </button>
            <button className="filter-done" onClick={this.props.hideDropdown}>
              Done
            </button>
          </div>
        ) : null}
      </div>
    )
  }
}

Filters.propTypes = {
  searchedAssets: PropTypes.array.isRequired,
  staticFilters: PropTypes.object,
  loading: PropTypes.bool,
  assetFilters: PropTypes.object,
  onReset: PropTypes.func,
  displayDropdown: PropTypes.bool,
  deviceType: PropTypes.string.isRequired,
  hideDropdown: PropTypes.func,
}

Filters.defaultProps = {
  searchedAssets: [],
  staticFilters: {},
  assetFilters: {},
}

export default Filters
